import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
export const Container = styled.div `
  display: flex;
  flex-direction: column;

  max-width: inherit; // Firefox fix, otherwise the text is not ellipsed

  gap: ${({ $dense }) => ($dense ? pxToRem(2) : '0')} 0;

  text-decoration: none;
`;
